<template>
  <PageHeader title="New Expense" icon="mdi-cash-register">
    <template v-slot:buttons>
      <v-btn color="primary" small dense class="ma-1" :to="{ name: 'UltimateTzSafebox' }"><v-icon dense>mdi-bank</v-icon> Safe</v-btn>
    </template>

    <Capture v-model="expense" v-if="!expense" />
    <Save v-model="expense" v-else-if="expense" />

  </PageHeader>

</template>

<script>
import lookups from '@/mixins/lookups';

import PageHeader from "@/components/PageHeader";
import Capture from '@/views/partners/ultimate_tz/expenses/Capture'
import Save from '@/views/partners/ultimate_tz/expenses/Save'

export default {

  components: { PageHeader, Capture, Save },

  data() {
    return {
      expense: undefined,
    }
  },

  mixins: [lookups],
}
</script>
